<!--
* UIID: UI-XMP-140
* UI Name: User Compoent Version History
* Modify Date: 2022/08/11
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>{{
        $t('lbl.userComponent.versionHistory.header')
      }}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup top text-->
      <v-card-text class="ml-4 pa-0 popup-title">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ options.item.data.uc_name }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top text-->

      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0 mb-2">
          <v-col cols="12" class="pa-0">
            <v-btn
              v-if="this.options.item.action != 'usercompsim'"
              class="mr-4 btn btn-popup-search float-right"
              color="primary"
              tile
              @click="openCheckIn"
              :disabled="itemToCheckIn.lock_yn != 'y'"
            >
              {{ $t('btn.dbMapperManager.checkIn') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="versionList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width: 51px">
                          {{ $t('tbl.userComponent.versionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" colspan="2" style="width: 117px">
                          {{ $t('tbl.userComponent.versionHistory.select') }}
                        </th>
                        <th class="text-center text-version" style="width: 133px">
                          {{ $t('tbl.userComponent.versionHistory.date') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.userComponent.versionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.userComponent.versionHistory.changeHistory') }}
                        </th>
                        <th class="text-center text-version" style="width: 60px">
                          {{ $t('tbl.userComponent.versionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.uc_ver }}</td>
                        <td
                          v-if="item.uc_current === 'y'"
                          class="text-left align-radio"
                          style="width: 29px"
                        >
                          <input
                            type="radio"
                            v-model="item.uc_current"
                            :value="item.uc_current"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.uc_current === 'n'"
                          class="text-left align-radio"
                          style="width: 29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width: 87px">
                          <a @click="openCheckOut(item)">{{
                            $t('tbl.dbMappeManager.versionHistory.checkOut')
                          }}</a>
                        </td>
                        <td class="text-left">{{ item.dep_dt }}</td>
                        <td class="text-left text-bold">{{ item.upd_user }}</td>
                        <td class="text-left">{{ item.uc_file_comment }}</td>
                        <td class="text-center">
                          <v-btn
                            v-if="
                              item.uc_current === 'y' || item.user_ver === currentVerItems.uc_ver
                            "
                            small
                            disabled
                            text
                            icon
                          >
                            <icon-svg :disabled="true" iconName="delete" />
                          </v-btn>
                          <v-btn v-else small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
      <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
      <v-row class="ml-0 mr-0">
        <v-col class="button-col action-col" lg="12">
          <div class="btn-form-control text-right mr-4">
            <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
              $t('btn.common.close')
            }}</v-btn>
            <v-btn
              v-if="this.options.item.action != 'usercompsim'"
              class="btn btn-popup-search btn-popup"
              color="primary"
              tile
              @click="saveVersionHistory"
              :disabled="itemToCheckIn.lock_yn != 'y'"
            >
              {{ $t('btn.userSimulator.deploy') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <dialogWindow
      ref="checkDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningDuplicationCheckOut')"
      color="confirmation"
      @select-ok="onClickCancel"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the User Component version'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailOkConfirm')"
      color="confirmation"
      show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningCheckIn')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.common.success.detail', ['User Component', 'deployed'])"
      color="success"
    >
    </dialogWindow>
    <dialogWindow
      ref="moveUserComponent"
      size="max"
      :detail="
        $t('msg.common.warning.moveConfirm', ['User Component in User Component Simulator?'])
      "
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickMove"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  data() {
    return {
      versionList: [],
      oldVersion: '',
      currentVerItems: {},
      seletedDelete: {},
      customHeight: 61,
      onSave: false,
      checkOutDialog: false,
      lockedFlag: false,
      fileId: null,
      moveData: null,
      itemToCheckIn: {},
    };
  },
  watch: {
    'options.item.data.uc_id'() {
      this.queryList();
    },
  },
  methods: {
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      if (this.onSave) return;
      showProgress();
      this.onSave = true;
      this.$store
        .dispatch('deleteUserComponentHistory', {
          uc_id: this.options.item.data.uc_id,
          uc_ver: this.seletedDelete.uc_ver,
        })
        .then(() => {
          this.queryList();
          this.versionList = this.$store.getters.userComponentHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.uc_current === 'y');
          this.oldVersion = this.currentVerItems.uc_ver;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
          this.onSave = false;
        })
        .catch(() => {
          hideProgress();
          this.onSave = false;
        });
    },
    openCheckOut(item) {
      this.fileId = item;
      if (item.lock_yn === 'n') {
        this.$refs.checkOutDialog.dialog = true;
      } else this.$refs.checkDialog.dialog = true;
    },
    onClickOkay() {
      Store.dispatch('toggleLocked', {
        uc_id: this.fileId.uc_id,
        lock_yn: this.fileId.lock_yn,
      }).then(() => {
        this.lockedFlag = true;
        this.$emit('refreshUserComponentList');
      });
      this.$refs.moveUserComponent.dialog = true;
    },
    onClickCancel() {
      this.$refs.moveUserComponent.dialog = true;
    },
    onClickMove() {
      this.viewFileMoveUserCompSim(this.fileId);
      this.$refs.moveUserComponent.dialog = false;
    },
    viewFileMoveUserCompSim(item) {
      this.$emit('viewFileMoveUserCompSim', item);
    },
    selectVersion(item) {
      this.currentVerItems = item;
    },
    openCheckIn() {
      if (this.itemToCheckIn.lock_yn === 'n' && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      this.$emit('openDeployUserComp', this.options.item.data);
    },
    queryList() {
      showProgress();
      this.$store
        .dispatch('userComponentHistory', { uc_id: this.options.item.data.uc_id })
        .then(() => {
          this.versionList = this.$store.getters.userComponentHistoryList;
          this.currentVerItems = this.versionList.find((e) => e.uc_current === 'y');
          this.oldVersion = this.currentVerItems.uc_ver;

          let len = this.versionList.length;
          this.customHeight = (len > 6 ? 6 : len) * 35 + (this.$vuetify.theme.dark ? 26 : 40);
          hideProgress();
        })
        .catch(() => {
          hideProgress();
        });
    },
    saveVersionHistory() {
      if (this.itemToCheckIn.uc_check_in_user == this.$cookies.get('user-id')) {
        showProgress();
        this.$store
          .dispatch('changeUserComponentVersionHistory', this.currentVerItems)
          .then(() => {
            this.$emit('refreshUcList');
            hideProgress();
            this.$refs.successDialog.dialog = true;
          })
          .catch(() => {
            hideProgress();
          });
      } else this.$refs.warningDialog.dialog = true;
    },
    removeDialog(dialog) {
      dialog.id = this.id;

      this.closeDialog(dialog);
      this.$emit('refreshUcList');
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  created() {
    this.itemToCheckIn = this.options.item.data;
    this.queryList();
  },
};
</script>

<style></style>
